import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { daysLeftSelector, setDaysLeft } from "../../store/refereeSlice";
import service from "./Helpers/gifservices";
import modules from "./modules/modules";

export default function Referee() {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const daysLeft = useSelector(daysLeftSelector);

  useEffect(() => {
    if (!!daysLeft) return;
    service.getDaysLeft().then((days) => {
      dispatch(setDaysLeft(days));
    });
  }, [dispatch, daysLeft]);

  return (
    <Switch>
      {modules.map(({ path, module: Module }) => (
        <Route
          key={path}
          path={`${match.url}${path}`}
          render={(props) => <Module {...props} baseUrl={match.url} />}
        />
      ))}
      <Redirect to={`${match.url}${modules[0].path}`} />
    </Switch>
  );
}
